import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'carnivore-diet-male',
	landing: {
		ids: ['loader-carnivore-diet-gs'],
		route: {
			path: '/carnivore-diet-m',
			name: 'carnivore-diet-male-funnel',
		},
	},
	funnel: {
		id: 'ob-carnivore-diet-male',
		route: {
			path: '/carnivore-diet-m/ob/:page(.*)?',
			name: 'carnivore-diet-male',
		},
		slug: 'carnivore-diet-male',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-carnivore-m',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-m'],
	},
}

export default appAreaConfig
